/**
 * Created by tomers on 9/21/2015.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/data-sources/integrations/app-keys/appKeyEditView.tmpl");

    var Dropdown = require("ui/dropdown/Dropdown");
    var InputField = require("ui/input-field/InputField");
    var ToggleButton = require("ui/toggle-button/toggleButton");
    var Button = require("ui/button/Button");

    var SECTION_SEPARATOR_CLASS = "with-separator";
    var ANDROID_ELEMENTS_SELECTOR = ".android";
    var IOS_ELEMENTS_SELECTOR = ".ios";
    var PROXY_ELEMENTS_SELECTOR = ".proxy";

    var AppKeyEditView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        AppKeyEditView = Marionette.ItemView.extend({
            className: "datasource-entity-edit-view",
            template: template,
            ui: {
                sectionAppType: ".section.app-type",
                appTypeDropdownContainer: ".app-type-dropdown-container",
                sectionCreateApp: ".section.create-app",
                platformDropdownContainer: ".platform .attribute-value",
                nameInputContainer: ".name .attribute-value",
                androidNotificationKeyInputContainer: ".android.notification-key .attribute-value",
                proxyEndPointURLInputContainer: ".proxy.endpoint-url .attribute-value",
                proxyAuthorizationHeaderInputContainer: ".proxy .authorization-header .attribute-value",
                proxyCertificateFileContainer: ".proxy .certificate-file .attribute-value",
                proxyCertificateFileRemove: ".proxy .certificate-file .attribute-remove",
                proxyKeyFileContainer: ".proxy .key-file .attribute-value",
                proxyKeyFileRemove: ".proxy .key-file .attribute-remove",
                iosProductionToggleContainer: ".ios .production .attribute-value",
                iosCertificateFileContainer: ".ios .certificate-file .attribute-value",
                iosCertificateFileRemove: ".ios .certificate-file .attribute-remove",
                iosKeyFileContainer: ".ios .key-file .attribute-value",
                iosKeyFileRemove: ".ios .key-file .attribute-remove",
                appKeyContainer: ".app-key-container",
                appKeyInputContainer: ".app-key-value",
                createAppButtonContainer: ".button-create-app",
                sectionCertificateFiles: ".section.certificate-files",
                sectionProxySettings: ".section.proxy-settings",
                closeButton: ".button-close"
            },
            uiComponents: {
                appTypeDropdown: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.appTypeDropdownContainer",
                        items: "view._getAppTypeDropdownOptions",
                        permutation: Dropdown.PERMUTATION.X_SMALL2,
                        enabled: false,
                        testCollision: true
                    }
                },
                platformDropdown: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.platformDropdownContainer",
                        items: "view._getPlatformDropdownOptions",
                        permutation: Dropdown.PERMUTATION.XX_SMALL1,
                        textCollision: true
                    },
                    events: {
                        "change": "_onPlatformChange"
                    }
                },
                nameInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.nameInputContainer",
                        maxLength: "view.model.MAX_NAME_LENGTH",
                        permutation: InputField.Permutation.B,
                        placeholder: LE.translator.translate("LEManager.appEdit.section.createApp.name.placeholder")
                    },
                    events: {
                        "onblur": "_onNameChange"
                    }
                },
                appKeyInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.appKeyInputContainer",
                        permutation: InputField.Permutation.O,
                        readonly: true
                    }
                },
                androidNotificationKeyInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.androidNotificationKeyInputContainer",
                        permutation: InputField.Permutation.B,
                        placeholder: LE.translator.translate("LEManager.appEdit.section.createApp.androidNotificationKey.placeholder")
                    },
                    events: {
                        "onblur": "_onAndroidNotificationKeyChange"
                    }
                },
                proxyEndPointURLInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.proxyEndPointURLInputContainer",
                        permutation: InputField.Permutation.B,
                        placeholder: LE.translator.translate("LEManager.appEdit.section.createApp.proxy.endpointURL.placeholder")
                    },
                    events: {
                        "onblur": "_onProxyEndpointURLChange"
                    }
                },
                proxyAuthorizationHeaderInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.proxyAuthorizationHeaderInputContainer",
                        permutation: InputField.Permutation.B,
                        placeholder: LE.translator.translate("LEManager.appEdit.section.proxySettings.authorizationHeader.placeholder")
                    },
                    events: {
                        "onblur": "_onProxyAuthorizationHeaderChange"
                    }
                },
                iosProductionToggleButton: {
                    type: ToggleButton,
                    options: {
                        container: "view.ui.iosProductionToggleContainer",
                        transition: ToggleButton.TRANSITION.FAST
                    },
                    events: {
                        "toggleButton:change": "_onProductionChange"
                    }
                },
                createAppButton: {
                    type: Button,
                    options: {
                        el: "view.ui.createAppButtonContainer",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onCreateAppClick"
                    }
                },
                closeButton: {
                    type: Button,
                    options: {
                        el: "view.ui.closeButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onCloseClick"
                    }
                }
            },
            events: {
                "click @ui.iosCertificateFileRemove": "_onIOSCertificateFileRemoveClick",
                "click @ui.iosKeyFileRemove": "_onIOSKeyFileRemoveClick",
                "click @ui.proxyCertificateFileRemove": "_onProxyCertificateFileRemoveClick",
                "click @ui.proxyKeyFileRemove": "_onProxyKeyFileRemoveClick"
            },
            modelEvents: {
                "change:operatingSystem": "_onModelChangePlatform"
            },

            //<editor-fold desc="Marionette-Functions">
            /*-----------------------------------------------------------------------------------------------*/
            initialize: function(options) {
                this._initialize(options);
            },

            onRender: function() {
                this._onRender();
            },
            //</editor-fold>


            //<editor-fold desc="privateFunctions">
            /*-----------------------------------------------------------------------------------------------*/
            _initialize: function(options) {
                this.channel = LEManager.media.channel("appKeyEdit");
                this._bindEvents();
                this.navigationEnabled = true;
                this.iosCertificateFileView = options.iosCertificateFileView;
                this.iosKeyFileView = options.iosKeyFileView;
                this.proxyCertificateFileView = options.proxyCertificateFileView;
                this.proxyKeyFileView = options.proxyKeyFileView;
            },

            _bindEvents: function() {
                this.listenTo(LEManager.vent, "app:enableNavigation", this._enableNavigation);
                this.listenTo(this.channel.vent, "app:createApp:success", this._onCreateAppSuccess);
                this.listenTo(this.channel.vent, "app:save:success", this._onSaveSuccess);
                this.listenTo(this.channel.vent, "app:save:error", this._onSaveError);
            },

            _onRender: function() {
                this.listenTo(this, "page:closeButtonClick", this._onCloseClick);
                this._renderFileUploadsComponents();
                this._updatePlatform();
                this._updateAppKey();
                this._updateSections();
                this._updateName();
                this._updateAndroidNotificationKey();
                this._updateProxyEndpointURL();
                this._updateProxyAuthorizationHeader();
                this._updateProduction();
            },

            _renderFileUploadsComponents: function() {
                this.ui.iosCertificateFileContainer.empty();
                this.ui.iosKeyFileContainer.empty();
                this.ui.proxyCertificateFileContainer.empty();
                this.ui.proxyKeyFileContainer.empty();

                if (this.iosCertificateFileView) {
                    this.ui.iosCertificateFileContainer.append(this.iosCertificateFileView.render().$el);
                    this.listenTo(this.iosCertificateFileView, "upload:fileSelectionChange", this._onIOSCertificateFileSelectionChange);
                    this._updateIOSCertificateFile();
                }

                if (this.iosKeyFileView) {
                    this.ui.iosKeyFileContainer.append(this.iosKeyFileView.render().$el);
                    this.listenTo(this.iosKeyFileView, "upload:fileSelectionChange", this._onIOSKeyFileSelectionChange);
                    this._updateIOSKeyFile();
                }

                if (this.proxyCertificateFileView) {
                    this.ui.proxyCertificateFileContainer.append(this.proxyCertificateFileView.render().$el);
                    this.listenTo(this.proxyCertificateFileView, "upload:fileSelectionChange", this._onProxyCertificateFileSelectionChange);
                    this._updateProxyCertificateFile();
                }

                if (this.proxyKeyFileView) {
                    this.ui.proxyKeyFileContainer.append(this.proxyKeyFileView.render().$el);
                    this.listenTo(this.proxyKeyFileView, "upload:fileSelectionChange", this._onProxyKeyFileSelectionChange);
                    this._updateProxyKeyFile();
                }
            },

            _updatePlatform: function() {
                this.uiComponents.platformDropdown.setSelection(this.model.getOperatingSystem());
                this.uiComponents.platformDropdown.setEnabled(this.model.isNew());
            },

            _updateAppKey: function() {
                var isModelNew = this.model.isNew();

                var isAppKeyContainerHidden = isModelNew;
                this.ui.appKeyContainer.toggleClass("hide", isAppKeyContainerHidden);

                var isCreateAppButtonEnabled = isModelNew;
                this.uiComponents.createAppButton.setEnabled(isCreateAppButtonEnabled);

                var appKeyInputValue = (isModelNew) ? "" : this.model.getAppKey();
                this.uiComponents.appKeyInput.setValue(appKeyInputValue);
            },

            _updateSections: function() {
                var isAndroid = this.model.isAndroid();
                var isIOS = this.model.isIOS();
                var isProxy = this.model.isProxy();
                this.$el.find(IOS_ELEMENTS_SELECTOR).toggleClass("hide", !isIOS);
                this.$el.find(ANDROID_ELEMENTS_SELECTOR).toggleClass("hide", !isAndroid);
                this.$el.find(PROXY_ELEMENTS_SELECTOR).toggleClass("hide", !isProxy);

                var showThirdSection = !this.model.isNew();
                if (isAndroid) {
                    this.ui.sectionCreateApp.removeClass(SECTION_SEPARATOR_CLASS);
                }
                else if (isIOS) {
                    this.ui.sectionCreateApp.toggleClass(SECTION_SEPARATOR_CLASS, showThirdSection);
                    this.ui.sectionCertificateFiles.toggleClass("hide", !showThirdSection);
                } else if (isProxy) {
                    this.ui.sectionCreateApp.toggleClass(SECTION_SEPARATOR_CLASS, showThirdSection);
                    this.ui.sectionProxySettings.toggleClass("hide", !showThirdSection);
                }
            },

            _updateName: function() {
                this.uiComponents.nameInput.setValue(this.model.getName());
            },

            _updateAndroidNotificationKey: function() {
                var androidNotificationKey = this.model.getAndroidNotificationKey();
                if (this.model.isAndroid() && !_.isEmpty(androidNotificationKey) && this.uiComponents.androidNotificationKeyInput) {
                    this.uiComponents.androidNotificationKeyInput.setValue(androidNotificationKey);
                }
                else {
                    this.uiComponents.androidNotificationKeyInput.setValue("");
                }
            },

            _updateProxyEndpointURL: function() {
                var endpointURL = this.model.getEndpointURL();
                if (this.model.isProxy() && !_.isEmpty(endpointURL) && this.uiComponents.proxyEndPointURLInput) {
                    this.uiComponents.proxyEndPointURLInput.setValue(endpointURL);
                }
                else {
                    this.uiComponents.proxyEndPointURLInput.setValue("");
                }
            },

            _updateProxyAuthorizationHeader: function() {
                var authorizationHeader = this.model.getProxyAuthorizationHeader();
                if (this.model.isProxy() && !_.isEmpty(authorizationHeader) && this.uiComponents.proxyEndPointURLInput) {
                    this.uiComponents.proxyAuthorizationHeaderInput.setValue(authorizationHeader);
                }
                else {
                    this.uiComponents.proxyAuthorizationHeaderInput.setValue("");
                }
            },

            _updateProxyCertificateFile: function() {
                var fileName = this.model.getCertificateFileName();
                if (this.model.isProxy()) {
                    if (this.proxyCertificateFileView.isFileSelected()) {
                        this.proxyCertificateFileView.resetUpload();
                    }

                    if (_.isEmpty(fileName)) {
                        this.proxyCertificateFileView.setFileInputLabelNoFileText();
                        this.proxyCertificateFileView.setFileInputLabelState(this.proxyCertificateFileView.FILE_INPUT_STATES.NON_EXISITING_FILE);
                        this.ui.proxyCertificateFileRemove.addClass("hide");
                    }
                    else {
                        this.proxyCertificateFileView.setFileInputLabelText(fileName);
                        this.proxyCertificateFileView.setFileInputLabelState(this.proxyCertificateFileView.FILE_INPUT_STATES.EXISITING_FILE);
                        this.ui.proxyCertificateFileRemove.removeClass("hide");
                    }
                }
            },

            _updateProxyKeyFile: function() {
                var fileName = this.model.getKeyFileName();
                if (this.model.isProxy()) {
                    if (this.proxyKeyFileView.isFileSelected()) {
                        this.proxyKeyFileView.resetUpload();
                    }

                    if (_.isEmpty(fileName)) {
                        this.proxyKeyFileView.setFileInputLabelNoFileText();
                        this.proxyKeyFileView.setFileInputLabelState(this.proxyKeyFileView.FILE_INPUT_STATES.NON_EXISITING_FILE);
                        this.ui.proxyKeyFileRemove.addClass("hide");
                    }
                    else {
                        this.proxyKeyFileView.setFileInputLabelText(fileName);
                        this.proxyKeyFileView.setFileInputLabelState(this.proxyKeyFileView.FILE_INPUT_STATES.EXISITING_FILE);
                        this.ui.proxyKeyFileRemove.removeClass("hide");
                    }
                }
            },

            _updateProduction: function() {
                var isProduction = this.model.getDevApp();
                if (this.model.isIOS()) {
                    this.uiComponents.iosProductionToggleButton.setChecked(isProduction);
                }
            },

            _updateIOSCertificateFile: function() {
                var fileName = this.model.getCertificateFileName();
                if (this.model.isIOS()) {
                    if (this.iosCertificateFileView.isFileSelected()) {
                        this.iosCertificateFileView.resetUpload();
                    }

                    if (_.isEmpty(fileName)) {
                        this.iosCertificateFileView.setFileInputLabelNoFileText();
                        this.iosCertificateFileView.setFileInputLabelState(this.iosCertificateFileView.FILE_INPUT_STATES.NON_EXISITING_FILE);
                        this.ui.iosCertificateFileRemove.addClass("hide");
                    }
                    else {
                        this.iosCertificateFileView.setFileInputLabelText(fileName);
                        this.iosCertificateFileView.setFileInputLabelState(this.iosCertificateFileView.FILE_INPUT_STATES.EXISITING_FILE);
                        this.ui.iosCertificateFileRemove.removeClass("hide");
                    }
                }
            },

            _updateIOSKeyFile: function() {
                var fileName = this.model.getKeyFileName();
                if (this.model.isIOS()) {
                    if (this.iosKeyFileView.isFileSelected()) {
                        this.iosKeyFileView.resetUpload();
                    }

                    if (_.isEmpty(fileName)) {
                        this.iosKeyFileView.setFileInputLabelNoFileText();
                        this.iosKeyFileView.setFileInputLabelState(this.iosKeyFileView.FILE_INPUT_STATES.NON_EXISITING_FILE);
                        this.ui.iosKeyFileRemove.addClass("hide");
                    }
                    else {
                        this.iosKeyFileView.setFileInputLabelText(fileName);
                        this.iosKeyFileView.setFileInputLabelState(this.iosKeyFileView.FILE_INPUT_STATES.EXISITING_FILE);
                        this.ui.iosKeyFileRemove.removeClass("hide");
                    }
                }
            },

            _onModelChangePlatform: function() {
                this._hideErrors();
                this._updateSections();
                this._updateAndroidNotificationKey();
            },

            _onPlatformChange: function(componentId, eventName, data) {
                this.channel.trigger("app:change:platform", data.selectedKey);
            },

            _onNameChange: function(componentId, eventName, value) {
                this.channel.trigger("app:change:name", value);
            },

            _onAndroidNotificationKeyChange: function(componentId, eventName, value) {
                this.channel.trigger("app:change:androidNotificationKey", value);
            },

            _onProxyEndpointURLChange: function(componentId, eventName, value) {
                this.channel.trigger("app:change:proxyEndpointURL", value);
            },

            _onProxyAuthorizationHeaderChange: function(componentId, eventName, value) {
                this.channel.trigger("app:change:proxyAuthorizationHeader", value);
            },

            _onProxyCertificateFileSelectionChange: function(data) {
                this.channel.trigger("app:change:proxyCertificateFile", data);
            },

            _onProxyKeyFileSelectionChange: function(data) {
                this.channel.trigger("app:change:proxyKeyFile", data);
            },

            _onProxyCertificateFileRemoveClick: function() {
                this.channel.trigger("app:remove:proxyCertificateFile");
            },

            _onProxyKeyFileRemoveClick: function() {
                this.channel.trigger("app:remove:proxyKeyFile");
            },

            _onProductionChange: function(componentId, eventName, enabled) {
                this.channel.trigger("app:change:production", enabled);
            },

            _onIOSCertificateFileSelectionChange: function(data) {
                this.channel.trigger("app:change:iosCertificateFile", data);
            },

            _onIOSKeyFileSelectionChange: function(data) {
                this.channel.trigger("app:change:iosKeyFile", data);
            },

            _onCreateAppClick: function() {
                this.channel.trigger("app:createApp");
            },

            _onIOSCertificateFileRemoveClick: function() {
                this.channel.trigger("app:remove:iosCertificateFile");
            },

            _onIOSKeyFileRemoveClick: function() {
                this.channel.trigger("app:remove:iosKeyFile");
            },

            _onCloseClick: function() {
                this.channel.trigger("app:close");
            },

            _onCreateAppSuccess: function(options) {
                this.iosCertificateFileView = options.iosCertificateFileView;
                this.iosKeyFileView = options.iosKeyFileView;
                this.proxyCertificateFileView = options.proxyCertificateFileView;
                this.proxyKeyFileView = options.proxyKeyFileView;

                this._hideErrors();
                this._renderFileUploadsComponents();
                this._updatePlatform();
                this._updateAppKey();
                this._updateSections();
            },

            _onSaveSuccess: function() {
                this._hideErrors();
                this._updateProxyCertificateFile();
                this._updateProxyKeyFile();
                this._updateIOSCertificateFile();
                this._updateIOSKeyFile();
            },

            _onSaveError: function(errors) {
                errors = errors || {};

                this._hideErrors();

                if (_.has(errors, this.model.KEYS.NAME)) {
                    this.uiComponents.nameInput.setError(true, errors[this.model.KEYS.NAME]);
                }

                if (_.has(errors, this.model.KEYS.KEY_FILE_DATA)) {
                    if (this.model.isAndroid()) {
                        this.uiComponents.androidNotificationKeyInput.setError(true, errors[this.model.KEYS.KEY_FILE_DATA]);
                    }
                }

                if (_.has(errors, this.model.KEYS.ENDPOINT_URL)) {
                    if (this.model.isProxy()) {
                        this.uiComponents.proxyEndPointURLInput.setError(true, errors[this.model.KEYS.ENDPOINT_URL]);
                    }
                }

                if (_.has(errors, this.model.KEYS.CERTIFICATE)) {
                    if (this.model.isIOS() && this.iosCertificateFileView) {
                        this.iosCertificateFileView.setError(errors[this.model.KEYS.CERTIFICATE]);
                    }
                    if (this.model.isProxy() && this.proxyCertificateFileView) {
                        this.proxyCertificateFileView.setError(errors[this.model.KEYS.CERTIFICATE]);
                    }
                }

                if (_.has(errors, this.model.KEYS.KEY)) {
                    if (this.model.isIOS() && this.iosKeyFileView) {
                        this.iosKeyFileView.setError(errors[this.model.KEYS.KEY]);
                    }
                    if (this.model.isProxy() && this.proxyKeyFileView) {
                        this.proxyKeyFileView.setError(errors[this.model.KEYS.KEY]);
                    }
                }
            },

            _hideErrors: function() {
                this.uiComponents.nameInput.setError(false);
                this.uiComponents.androidNotificationKeyInput.setError(false);
                if (this.iosCertificateFileView) {
                    this.iosCertificateFileView.setError(false);
                }
                if (this.iosKeyFileView) {
                    this.iosKeyFileView.setError(false);
                }
                if (this.proxyCertificateFileView) {
                    this.proxyCertificateFileView.setError(false);
                }
                if (this.proxyKeyFileView) {
                    this.proxyKeyFileView.setError(false);
                }
            },

            _getAppTypeDropdownOptions: function() {
                var items = [
                    {key:0, value:LE.translator.translate("LEManager.appEdit.section.appType.option.lesdk")}
                ];
                return new Dropdown.Collection(items);
            },
            _getPlatformDropdownOptions: function() {
                var items = _.map(this.model.OPERATING_SYSTEMS, function(enumValue, enumKey) {
                    return {
                        key: enumValue,
                        value: LE.translator.translate("LEManager.appEdit.section.createApp.platform." + enumKey.toLowerCase())
                    };
                });
                return new Dropdown.Collection(items);
            },

            _enableNavigation: function(enabled) {
                this.navigationEnabled = enabled;
                this.uiComponents.host$.setEnabledAll(enabled);
                if (enabled) {
                    this.uiComponents.appTypeDropdown.setEnabled(false); // hard-coded disabled
                    this._updatePlatform();
                    this._updateSections();
                    this._updateAppKey();
                }
            }
            //</editor-fold>
        });
    }

    LE.module("LEManager", moduleDefinition);

    return AppKeyEditView;
});
